import { SeverityLevel } from "@sentry/react";

import { HttpErrorClass } from "./getHttpErrorClass";

export const SENTRY_WARNING: SeverityLevel = "warning";
export const SENTRY_ERROR: SeverityLevel = "error";

export const getSentryLevel = (errorClass: HttpErrorClass): SeverityLevel => {
  return errorClass === "4xx" ? SENTRY_WARNING : SENTRY_ERROR;
};
